/** Main context for registration form */
import React, { useContext, useState, useEffect } from 'react'
import { strings } from "../assets/resources/translations"
import { usePrice } from '../hooks/usePrice'
import { useForm, useFormWrapper } from '../hooks/useForm'
import { send } from '../services/send';
import { createTitle } from '../services/utils/createContent'


const RegistrationContext = React.createContext()

export const RegistrationProvider = ({ children, init }) => {
	const [config, setConfig] = useState(init)
	const [isLoading, setIsLoading] = useState(false)
	const [isSubmitted, setIsSubmitted] = useState(false)
	const [submitError, setSubmitError] = useState()
	const [displayErrors, setDisplayErrors] = useState(false)

	const wrapper = useFormWrapper()
	const { inputs, isValid } = wrapper

	const price = usePrice()


	const submit = async (isPreview) => {
		if (isValid) {
			setIsLoading(true)
				await send({ ...inputs, market: config.market, name: config.title, category: config.category, type: config.type, event: config.event, price }, isPreview)
				.then(res => {
					setIsSubmitted(true)
					setSubmitError()
				})
				.catch(error => {
					setSubmitError(strings.errorSend)
				})

			setIsLoading(false)


			//	window.scrollTo(0, 0)
		} else {
			//	window.scrollTo(0, 0)
			setDisplayErrors(true)
			setSubmitError(strings.errorNotValid || "Not valid or missing inputs")
		}
	}

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [isSubmitted])

	useEffect(() => {
		if (!config.title || config.title === "") {
			const title = createTitle(config, strings)
			setConfig({ ...config, title })
		}
	}, [])

	useEffect(() => {
		if (isValid) {
			setSubmitError()
		}
	}, [isValid])

	return (
		<RegistrationContext.Provider value={{ config, price, wrapper, submit, isSubmitted, submitError, displayErrors }}>
			{children}
		</RegistrationContext.Provider>
	)
}

export const useRegistrationContext = () => { return useContext(RegistrationContext) }